export default "__VITE_ASSET__s3rQU76i__"